module.exports = __webpack_public_path__ + "img/plutella-xylostella.9a9f0753.jpg";